import {
  pick, isNil, omitBy,
} from 'lodash-es';
import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/services/api';
import { hasRawCookie, setRawCookie } from '@/services/helpers/cookie';
import { signatureRequest } from '@/services/api/document/document';

import * as modules from '@/store/modules';

Vue.use(Vuex);

const plugins = [];
const DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN;
const store = new Vuex.Store({
  state: {
    isAnUnicorn: false,
  },
  getters: {
    risk: (state, getters) => ({
      ...omitBy(getters['company/get'], (obj) => isNil(obj) || obj === ''),
    }),
    signedDocuments: (state, getters) => (getters['company/get']),
    isAnUnicorn: (state) => state.isAnUnicorn,
    sentry: (unused, getters) => {
      const company = JSON.stringify(pick(getters['company/get'],
        ['mainActivity', 'companyType', 'codeNaf.name', 'revenue']));
      return { company };
    },
  },
  actions: {
    noop: () => {},
    signature(unset, { requestId, event }) {
      if (requestId && event) {
        return signatureRequest(requestId, event);
      }
      return Promise.resolve();
    },
    newQuote({ dispatch }) {
      dispatch('order/clear');
      dispatch('invoice/clear');
    },
    async specialEvent({ commit }, token) {
      commit('SET_VALUE', { isAnUnicorn: true });
      setRawCookie('access_token', token, { domain: DOMAIN });
    },
    async authenticate({ dispatch }, { token, id, unicorn }) {
      await api().initialize();
      if (token && !id && !unicorn) {
        await dispatch('client/handleAutoAuthentication', token, { root: true });
      }
      if (hasRawCookie('access_token')) {
        await api().setAuthorization();
        const { haveSignature } = await dispatch('client/authenticate', true, { root : true });
        return Promise.resolve({ isLogged: true, haveSignature });
      }
      return Promise.resolve({ isLogged: false });
    },
    async changeAccount({ dispatch }) {
      return dispatch('client/disconnect');
    },
    async disconnect({ dispatch }) {
      dispatch('client/disconnect');
      dispatch('ui/forceAssistantMessage', null);
      dispatch('reset');
    },
    setValue({ commit }, object) {
      commit('SET_VALUE', object);
    },
    reset: ({ dispatch }) => {
      dispatch('ui/forceAssistantMessage', null);
      dispatch('client/clear');
      dispatch('company/clearOne');
      dispatch('contracts/clear');
      dispatch('contract/clear');
      dispatch('checkout/clear');
      dispatch('invoice/clear');
      dispatch('invoices/clear');
      dispatch('orders/clear');
      dispatch('perks/clear');
      dispatch('transactions/clear');
    },
  },
  mutations: {
    SET_VALUE(state, object) {
      const [key] = Object.keys(object);
      state[key] = object[key] || null;
    },
  },
  modules,
  plugins,
});

export default store;
